import { render } from "./UsersUpload.vue?vue&type=template&id=44f0935f"
import script from "./UsersUpload.vue?vue&type=script&lang=js"
export * from "./UsersUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__